import { Card, CardContent, Typography, Tooltip, IconButton, Stack, Divider, Box, linearProgressClasses, LinearProgress } from "@mui/material";
import styled from "styled-components";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { colors } from "styles/colors";
import { colorProgress } from "utils/colorProgress";

const BorderLinearProgress = styled(LinearProgress)(({ value }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: colors.gray_block,
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: colorProgress(value),
    },
}));


const ProgressTask = ({ data }) => (
    <div>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '70%', mr: 1 }}>
                <Typography variant='h5' >{data.nameTask}</Typography>
            </Box>
            <Box sx={{ width: '30%', mr: 1 }}>
                <BorderLinearProgress variant="determinate" value={data.progress} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography sx={{ color: colorProgress(data.progress) }} variant="body2" color="text.secondary">{`${Math.round(
                    data.progress,
                )}%`}</Typography>
            </Box>
        </Box>
        {data.subTasks.map((value) =>
            <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5 }}>
                {value.check ? <div style={{
                    display: 'flex',
                    width: '14px',
                    height: '14px',
                    backgroundColor: colors.status.high,
                    borderRadius: '50%'
                }} /> :
                    <div style={{
                        display: 'flex',
                        width: '14px',
                        height: '14px',
                        backgroundColor: 'white',
                        border: '2px solid',
                        borderColor: colors.status.high,
                        borderRadius: '50%'
                    }} />
                }

                <Typography style={{ marginLeft: 10 }} variant="body2" color="text.secondary">{value.nameTask}</Typography>
            </div>
        )}

    </div>
);


export default function Tasks ({ data }) {
    return (
    <Card sx={{ borderRadius: 3, boxShadow: 5 }}>
        <CardContent>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Typography variant="h3" style={{ marginBottom: 15 }} >Задачи</Typography>
                <Tooltip title="Задачи">
                    <IconButton sx={{ p: 0, marginInline: '6px' }}>
                        <MoreVertIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <Stack divider={<Divider orientation='horizontal' flexItem style={{ backgroundColor: 'gray' }} />} spacing={1}>
                {data.map((value) =>
                    <ProgressTask data={value}></ProgressTask>
                )}
            </Stack>
        </CardContent>
    </Card>
);
}